import { ComponentLoader } from '@bythepixel/component-loader';
import TypesTabs from '@Front/modules/pages/makes/typesTabs';

window.makesPage = new ComponentLoader(document, [TypesTabs]);
